import toTitleCase from './to-title-case';

export { toTitleCase };

export default toTitleCase;
